<mat-toolbar color="accent">ACC Invoice Request Details</mat-toolbar>

<div class="flex flex-col gap-2 bg-gray-50 p-4">
  <div class="flex items-center justify-between">
    <div
      class="bg-primary-50 text-primary-700 flex w-36 flex-col rounded-md px-2 py-1"
    >
      <span class="font-bold">Invoice ID</span>
      <span class="text-base">{{ data.accInvoice.invoiceId }}</span>
    </div>
    <div class="flex w-36 flex-col rounded-md p-2" [ngClass]="statusClasses">
      <span class="font-bold">Status</span>
      <span class="text-base">
        {{ data.invoiceRequest.status | splitCamel | titlecase }}
      </span>
    </div>
  </div>

  <div class="rounded-md border border-solid border-gray-300 bg-white p-3">
    <div class="mb-2 font-semibold opacity-90">Patient Information</div>
    <div class="grid grid-cols-2 gap-4">
      <div class="space-y-2">
        <div>
          <span class="font-medium">Name:</span>
          {{ data.invoiceRequest.patient.name }}
        </div>
        <div>
          <span class="font-medium">NHI:</span>
          {{ data.accInvoice.lines[0].patient?.nhi || 'Not provided' }}
        </div>
        <div>
          <span class="font-medium">DOB:</span>
          {{
            data.accInvoice.lines[0].patient?.dateOfBirth
              | moment
              | amDateFormat: dateFormat
          }}
        </div>
      </div>
      <div class="space-y-2">
        <div>
          <span class="font-medium">Patient Surname:</span>
          {{ data.accInvoice.lines[0].patient?.surname }}
        </div>
        <div>
          <span class="font-medium">Patient First Name:</span>
          {{ data.accInvoice.lines[0].patient?.firstName }}
        </div>
      </div>
    </div>
  </div>

  <div class="rounded-md border border-solid border-gray-300 bg-white p-3">
    <div class="mb-2 font-semibold opacity-90">Claim Information</div>
    <div class="grid grid-cols-2 gap-4">
      <div class="space-y-2">
        <div>
          <span class="font-medium">Claim ID:</span>
          {{ data.accInvoice.lines[0].claimId }}
        </div>
        <div>
          <span class="font-medium">Accident Date:</span>
          {{
            data.accInvoice.lines[0].accidentDate
              | moment
              | amDateFormat: dateFormat
          }}
        </div>
        <div>
          <span class="font-medium">Service Date:</span>
          {{
            data.accInvoice.lines[0].lineDetails?.serviceDate
              | moment
              | amDateFormat: dateFormat
          }}
        </div>
      </div>
      <div class="space-y-2">
        <div>
          <span class="font-medium">Service Codes:</span>
          {{ serviceCodes }}
        </div>
        <div>
          <span class="font-medium">Invoice Amount:</span>
          {{ invoiceAmount | currency }}
        </div>
      </div>
    </div>

    <div *ngIf="data.accInvoice.comment as comment" class="mt-2">
      <span class="font-medium">Invoice Comments: </span>
      {{ comment }}
    </div>
  </div>

  @if (this.data.invoiceRequest.data.invoiceStatusDetails; as lineDetails) {
    @if (lineDetails.length) {
      <div class="-mb-1 ml-2 mt-1 font-semibold opacity-90">
        Invoice Line Items
      </div>
      @for (line of lineDetails; track $index) {
        <div
          class="grid grid-cols-2 gap-4 rounded-md border border-solid border-gray-300 bg-white p-3"
        >
          <div class="space-y-2">
            <div>
              <span class="font-medium">Service Code:</span>
              {{ line.serviceCode }}
            </div>
            <div>
              <span class="font-medium">Payment Status:</span>
              {{ line.paymentStatus }}
            </div>
          </div>

          <div class="space-y-2">
            <div>
              <span class="font-medium">Claimed Amount:</span>
              {{ line.claimedAmount ?? 0 | currency }}
            </div>
            <div>
              <span class="font-medium">Amount Awarded:</span>
              {{ line.awarded ?? 0 | currency }}
            </div>
          </div>
        </div>
      }
    }
  }
</div>
